// users.ts — Endpoints utilisateurs : CRUD, invitation, replacement, groupes.
import { req } from './_internals.js';

export const usersApi = {
  // Users
  // `manage: true` → scope gestion : inclut les comptes admin techniques (DMO),
  // réservé aux pages d'administration users/groupes. Sans option → scope
  // sélecteurs : exclut les comptes admin techniques (cf. règle 12).
  getUsers: (opts?: { manage?: boolean }) =>
    req('GET', '/users' + (opts?.manage ? '?scope=manage' : '')),
  createUser: (d: unknown) => req('POST', '/users', d),
  updateUser: (id: number | string, d: unknown) => req('PUT', '/users/' + id, d),
  deleteUser: (id: number | string) => req('DELETE', '/users/' + id),
  inviteUser: (id: number | string) => req('POST', '/users/' + id + '/invite'),
  sendUserInvitation: (id: number | string) => req('POST', '/users/' + id + '/invite/send'),

  // User replacement (transfert en masse A → B)
  previewUserReplacement: (d: unknown) => req('POST', '/user-replacement/preview', d),
  applyUserReplacement: (d: unknown) => req('POST', '/user-replacement/apply', d),

  // User groups (permissions)
  getUserGroups: () => req('GET', '/user-groups'),
  getUserGroup: (id: number | string) => req('GET', '/user-groups/' + id),
  createUserGroup: (d: unknown) => req('POST', '/user-groups', d),
  updateUserGroup: (id: number | string, d: unknown) => req('PUT', '/user-groups/' + id, d),
  deleteUserGroup: (id: number | string) => req('DELETE', '/user-groups/' + id),
  getAvailablePermissions: () => req('GET', '/user-groups/available-permissions'),
};
